/**
 * `<sticky-cart>` custom element (feature list v1.2).
 *
 * The bar shows up when the buy buttons scroll out of view; its button
 * clicks the real add button of the page's `<product-form>`, so variant
 * selection, quantity rules, fetch, inline confirmation and the cart
 * drawer are all the form's own — nothing is duplicated here.
 */
class StickyCart extends HTMLElement {
  connectedCallback() {
    const form = document.querySelector('product-form');
    const add = form ? form.querySelector('button[name="add"]') : null;
    const button = this.querySelector('[data-sticky-cart-add]');
    if (!form || !add || !button) return;

    button.addEventListener('click', () => add.click());

    new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        this.hidden = entry.isIntersecting;
      });
    }).observe(form);
  }
}

if (!customElements.get('sticky-cart')) {
  customElements.define('sticky-cart', StickyCart);
}
